import {gql} from "@apollo/client";

const GET_SEARCH_HIT_LIST: any = gql`
    query GetSearchHitList($search: String!, $offset: Int, $limit: Int, $siteId: String, $docTypes: [String]) {
        content {
            search(query: $search, offset: $offset, limit: $limit, docTypes: $docTypes, siteId: $siteId, includeSubTypes: false) {
                numFound
                result {
                    id
                    type
                    ... on CMTeasable {
                        creationDate
                        teaserTitle
                        title
                        selfUrl
                        teaserText {
                            text
                            textAsTree }
                        picture {
                            id
                            name
                            data {
                                uri
                            }
                        }
                        teaserTarget {
                            id
                            navigationPath {
                                id
                                title
                            }
                        }
                    }
                    ... on SOSJobTeaser {
                        deepLink
                    }
                }
            }
        }
    }
`;

export default GET_SEARCH_HIT_LIST
